import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { sessionStorage, STORAGE_KEYS, authStateTracking } from '../utils/sessionStorage';

const AuthCallbackScreen: React.FC = () => {
  const { isLoading, error, isAuthenticated } = useAuth0();
  const { fetchUserRoles } = useAuth(); // Add this line
  const navigate = useNavigate();
  
  useEffect(() => {
    // Redirect after authentication is complete
    if (!isLoading && isAuthenticated && !error) {
      console.log('AuthCallbackScreen: Authentication complete, checking for saved route');
      
      // Clear authentication in progress flag
      authStateTracking.clearAuthInProgress();
      
      // Fetch user roles
      fetchUserRoles(); // Add this line
      
      // Check for saved route in session storage
      const savedRoute = sessionStorage.getItem<{pathname: string, state: any}>(STORAGE_KEYS.ROUTE);
      
      if (savedRoute) {
        console.log('AuthCallbackScreen: Redirecting to saved route:', savedRoute.pathname);
        navigate(savedRoute.pathname, {
          state: savedRoute.state
        });
      } else {
        // Default to home if no saved route
        console.log('AuthCallbackScreen: No saved route, navigating to home');
        navigate('/home');
      }
    } else if (!isLoading && error) {
      // Clear authentication in progress flag on error
      authStateTracking.clearAuthInProgress();
    }
  }, [isLoading, isAuthenticated, error, navigate, fetchUserRoles]); // Add fetchUserRoles to dependencies
  
  if (isLoading) {
    return (
      <div className="callback-container">
        <div className="loading-indicator">
          <h2>Completing Authentication...</h2>
          <p>Please wait while we complete the authentication process.</p>
        </div>
      </div>
    );
  }
  
  if (error) {
    return (
      <div className="callback-container">
        <div className="error-message">
          <h2>Authentication Error</h2>
          <p>{error.message}</p>
          <button onClick={() => navigate('/login')}>Return to Login</button>
        </div>
      </div>
    );
  }
  
  return (
    <div className="callback-container">
      <div className="success-message">
        <h2>Authentication Successful</h2>
        <p>You have been successfully authenticated. Redirecting...</p>
      </div>
    </div>
  );
};

export default AuthCallbackScreen;